import React, { useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import {
  TwoColumnSection,
  LeftColumn,
  WhoWeAre,
  ConsultingText,
  RightColumn,
  DescriptionText
} from "./TwoColumnStyles";

const fadeInLeft = { hidden: { opacity: 0, x: -30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } } };
const fadeInRight = { hidden: { opacity: 0, x: 30 }, visible: { opacity: 1, x: 0, transition: { duration: 0.6, ease: "easeOut" } } };

export default function TwoColumn({ data = {} }) {
  const { label = "Who are we", heading = "", paragraphs = [] } = data;
  const twoColumnRef = useRef(null);
  const twoColumnControls = useAnimation();
  const twoColumnInView = useInView(twoColumnRef, { once: true });

  React.useEffect(() => {
    if (twoColumnInView) twoColumnControls.start("visible");
  }, [twoColumnInView, twoColumnControls]);

  return (
    <TwoColumnSection ref={twoColumnRef}>
      <motion.div initial="hidden" animate={twoColumnControls} variants={fadeInLeft}>
        <LeftColumn>
          <WhoWeAre>{label}</WhoWeAre>
          <ConsultingText>{heading}</ConsultingText>
        </LeftColumn>
      </motion.div>

      <motion.div initial="hidden" animate={twoColumnControls} variants={fadeInRight}>
        <RightColumn>
          <DescriptionText>
            {paragraphs.map((para, i) => (
              <p key={i}>{para}</p>
            ))}
          </DescriptionText>
        </RightColumn>
      </motion.div>
    </TwoColumnSection>
  );
}
